import { useState } from 'react';
import * as React from 'react';
import { Alert, Button, Form, Input, PageHeader } from 'antd';
import { useHistory } from 'react-router';
import api from '@/api';
import { API_COMPANY_CAR, PATH_COMPANY_CAR } from '@/constants/constant';

const CompanyCarWritePage: React.FC = () => {
  const history = useHistory();
  const [error, setError] = useState('');
  return (
    <PageHeader
      title="차량 등록"
      subTitle="신규 차량을 등록합니다."
      style={{ background: '#fff', border: '1px solid rgb(235, 237, 240)' }}
      onBack={() => window.history.back()}
    >
      <Form
        onFinish={(values) => {
          api
            .post(API_COMPANY_CAR, 'pcompany.PbCompanyCarCreateRequest', {
              car: [{ ...values, companyId: 1 }],
            })
            .then(() => history.replace(PATH_COMPANY_CAR))
            .catch((e) => {
              console.log(e.response.data);
              setError(e.response.data.message);
            });
        }}
      >
        <Form.Item name="plateNo" rules={[{ required: true }]} label="차량번호">
          <Input placeholder="예 : 10호1234" />
        </Form.Item>
        {error && <Alert message={error} type="error" closable onClose={() => setError('')} style={{ marginBottom: '10px' }} />}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            등록
          </Button>
        </Form.Item>
      </Form>
    </PageHeader>
  );
};

export default CompanyCarWritePage;
